import {
  StyledLoadingAlert,
  StyledLoadingAlertDesc,
  StyledLoadingAlertIllustration,
  StyledLoadingAlertTitle
} from './LoadingAlert.style';
import PurpleDudeComputerImg from './images/PurpleDudeComputer.svg';

const LoadingAlert = ({ title, description }) => {
  return (
    <StyledLoadingAlert>
      <main>
        <StyledLoadingAlertTitle>{title}</StyledLoadingAlertTitle>
        <StyledLoadingAlertDesc>{description}</StyledLoadingAlertDesc>
        <StyledLoadingAlertIllustration src={PurpleDudeComputerImg} alt='' />
      </main>
    </StyledLoadingAlert>
  );
};

export default LoadingAlert;
